module.exports = __webpack_public_path__ + "static/media/test12_3.7ea2994e.png";